import { render, staticRenderFns } from "./_post.vue?vue&type=template&id=f7059842"
import script from "./_post.vue?vue&type=script&lang=js"
export * from "./_post.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports